import React from 'react';
import { MortgageCalculator } from './pages/MortgageCalculator';
export function App() {
  return <MortgageCalculator data-id="element-0" />;
}